module.exports = __webpack_public_path__ + "static/pic05-a06a144f8099f4242540e8b94df0ac67.jpg";